import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import styles from './modal.module.scss';

const Modal = ({ children }) => {
  const modalRoot = document.getElementById('modal');
  const { t } = useTranslation();
  const [pendingFunction, setPendingFunction] = useState({
    action: null,
    cancel: null,
    message: null,
  });

  function childrenWithProps() {
    return React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          confirm: (action, message, cancel) => setPendingFunction({
            action,
            cancel,
            message,
          }),
        });
      }
      return child;
    });
  }

  function confirmAction(bool) {
    if (bool) pendingFunction.action();
    else if (!bool && pendingFunction.cancel) pendingFunction.cancel();
    setPendingFunction({
      action: null,
      message: null,
    });
  }

  return (
    <>
      {(pendingFunction.action && pendingFunction.message) && (
        <>
          {createPortal(
            <>
              <div className={styles['overlay-modal']} />
              <div className={styles.modal}>
                <p>{pendingFunction.message}</p>
                <div className={styles['container-btn']}>
                  <button onClick={() => confirmAction(true)}>
                    <span>{t('btn.confirm')}</span>
                  </button>
                  <button onClick={() => confirmAction(false)}>
                    <span>{t('btn.cancel')}</span>
                  </button>
                </div>
              </div>
            </>,
            modalRoot,
          )}
        </>
      )}
      {childrenWithProps(children)}
    </>
  );
};

const withModalConfirm = (Component) => ({ ...props }) => (
  <Modal>
    <Component {...props} />
  </Modal>
);

export default withModalConfirm;
